<script>
    import R from "../lib/requests";
    import clocking from "../stores/clocking";
    import {setFocusTo, YMD_HMS} from "../lib/lib";
    import {createEventDispatcher} from 'svelte/internal';
    import TimerField from "./TimerField.svelte";
    import ProjectSelectControl from "../projects/ProjectSelectControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import TagsControl from "../components/controls/TagsControl.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";


    const dispatch = createEventDispatcher();

    export const startClocking = () => {
        clocking.start($clocking.task);
    }

    const stopClocking = () => {
        if (!$clocking.task.name) {
            Notifier.showError("Εισάγετε το όνομα της εργασίας!");
            setFocusTo('clockingTaskName');
            return;
        }
        if (!$clocking.task.project_id || $clocking.task.project_id == 0) {
            Notifier.showError("Δεν έχει επιλεχτεί project!");
            return;
        }
        $clocking.task.end_at = YMD_HMS(new Date());
        save();
    }

    const save = () => {
        const onSuccess = result => {
            if ($clocking.task.end_at != null) {
                dispatch('complete', $clocking.task);
                clocking.clear();
                Notifier.showMessage("Η χρονομέτρηση εργασίας ολοκληρώθηκε");
            }
        }

        const onFailure = err => {
            if (err.code && err.code === 'not_defined') {
                if (err.params.object === 'project') {
                    Notifier.showError("Δεν έχει οριστεί project για την εργασία!");
                }
            }
        };

        if ($clocking.task.id == 0) {
            return;
        }

        R.handle(R.clockingTask.edit, $clocking.task, onSuccess, onFailure);
    }

    const onCancelClocking = () => {
        Alert.confirm("Εργασία", "Ακύρωση εργασίας;", cancelClocking);
    }

    const cancelClocking = () => {
        const onSuccess = result => {
            clocking.clear();
            Notifier.showMessage("Η χρονομέτρηση εργασίας ακυρώθηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.clockingTask.delete, $clocking.task.id, onSuccess, onFailure);
    }

    const timeFieldChange = ({detail}) => {
        $clocking.task.start_at = detail;
        $clocking.task.date = new Date($clocking.task.start_at);
        $clocking.task.duration = new Date() - $clocking.task.date;
        save();
    }

    const onProjectChange = ({detail: project}) => {
        console.log("onProjectChange", project);
        $clocking.task.project = project;
        $clocking.task.project_id = project.id;
        // $clocking.task.is_billable = project.is_billable ? 1 : 0;
        save();
    }

    const onToggleBillable = () => {
        $clocking.task.is_billable = $clocking.task.is_billable == 1 ? 0 : 1;
        Notifier.showMessage($clocking.task.is_billable == 1 ? "Η εργασία είναι με χρέωση" : "Η εργασία είναι χωρίς χρέωση")
        save();
    }

    if (!$clocking.task) {
        clocking.clear();
    } else {
        clocking.setDuration();
    }
</script>

{#if $clocking.task}
    <div class="panel panel-default box-border mb-6">
        <div class="panel-body">
            <div class="clocking-task">
                <div class="state-icon" class:active={ $clocking.task.id > 0 }>
                    <AppIcon icon="clock" size="full"/>
                </div>
                <div class="inputs">
                    <div class="column name">
                        <input type="text" id="clockingTaskName" class="form-control minimal"
                               bind:value="{ $clocking.task.name }"
                               on:change={ save } placeholder="τι θα δουλέψω;"/>
                    </div>
                    <div class="column project">
                        <ProjectSelectControl project="{ $clocking.task.project }" on:change="{ onProjectChange }"/>
                    </div>
                    <div class="column tags border-after">
                        <TagsControl bind:tags={ $clocking.task.tags } clockingTask inline on:change={ save }/>
                    </div>
                </div>
                <div class="controls">
                    <div class="column billable border-after">
                        <button class="btn btn-icon" class:text-gray={ $clocking.task.is_billable == 0 }
                                class:blue-icon={ $clocking.task.is_billable == 1 } title="εργασία με χρέωση" on:click={ onToggleBillable }>
                            <AppIcon icon="euro" size="14"
                                     strokeWidth="{ $clocking.task.is_billable == 1 ? 3 : 1 }"/>
                        </button>
                    </div>
                    <div class="column duration border-after">
                        <TimerField startAt="{ $clocking.task.start_at }" duration="{ $clocking.task.duration }"
                                    on:change="{ timeFieldChange }"/>
                    </div>
                    {#if $clocking.task.date}
                        <div class="column pe-0">
                            <button class="btn btn-danger py-2 px-4" title="λήξη" on:click="{ stopClocking }">
                                <AppIcon icon="square" strokeWidth="2"/>
                            </button>
                        </div>
                        <div class="column">
                            <button class="btn btn-default py-2 px-2" title="ακύρωση εργασίας"
                                    on:click="{ onCancelClocking }">
                                <AppIcon icon="x"/>
                            </button>
                        </div>
                    {:else}
                        <div class="column">
                            <button class="btn btn-primary py-2 px-4" title="έναρξη" on:click="{ startClocking }">
                                <AppIcon icon="play" strokeWidth="2"/>
                            </button>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .clocking-task {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    /*.clocking-task:before {*/
    /*    position: absolute;*/
    /*    content: " ";*/
    /*    display: block;*/
    /*    clear: both;*/
    /*    background: #ccc;*/
    /*    border-radius: 50%;*/
    /*    border: 1px solid #000;*/
    /*    width: 25px;*/
    /*    height: 25px;*/
    /*    top: -13px;*/
    /*    left: 2px;*/
    /*    z-index: -1;*/
    /*}*/

    .clocking-task .state-icon {
        position: absolute;
        background: #fff;
        border-radius: 50%;
        /* border: 1px solid transparent; */
        width: 20px;
        height: 20px;
        top: -10px;
        left: 3px;
        color: #b0b1b3;
    }

    .clocking-task .state-icon.active {
        animation: color-change 2s infinite;
    }

    @keyframes color-change {
        0% {
            color: #b0b1b3;
        }
        50% {
            color: #333;
        }
        100% {
            color: #b0b1b3;
        }
    }

    .clocking-task .inputs {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: calc(100% - 254px);
    }

    .clocking-task .controls {
        display: flex;
        align-items: center;
    }

    .clocking-task .column {
        padding: 10px 10px;
    }

    .clocking-task .name {
        width: 40%;
    }

    .clocking-task .project {
        width: 25%;
    }

    .clocking-task .tags {
        width: 35%;
        text-align: right;
    }

    .clocking-task .billable {
        padding-left: 0;
        padding-right: 0;
    }

    .clocking-task .duration {
        width: 130px;
    }

</style>